/* eslint-disable react/destructuring-assignment,  no-unneeded-ternary, react/no-unused-state */
/* eslint-disable class-methods-use-this,react/no-unused-class-component-methods */
/* eslint-disable react/sort-comp,react/no-unused-class-component-methods */

import React, { useEffect } from "react"
import withStyles from '@material-ui/core/styles/withStyles'
import { ClickAwayListener, Container, Button, Tabs, Tab } from '@material-ui/core';
import i18n from 'support/i18n'
import Navigation from 'support/navigation'
import Breadcrumbs from 'components_newui/pageBreadcrumbsMenu/View'
import styles from './View.Style'
import EvaluationBoardNOVA from './Nova'
import { EvaluationInnovateIdea } from "./EvaluationInnovateIdea";
import { EvaluationMyIdea } from "./EvaluationMyIdea";
import { EvaluationMyIdeaHistory } from "./EvaluationMyIdeaHistory";



const a11yProps = (index) => {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}


const EvaluationBoard = (props) => {
  const { isAdmin, classes, ideas, getEvaluationIdea, params, isEvaluator, getEvaluationDashboadInnovateIdeaFn, getEvaluationDashboardIdea, getEvaluationDashboadInnovateMyIdeaHistoryFn, getMyEvaluationDashboardIdeaHistory, getMyEvaluationDashboardIdeaHistoryFn } = props || {}
  const [value, setValue] = React.useState(0);


  useEffect(() => {
    getEvaluationDashboadInnovateIdeaFn?.()
  }, [])

  //console.log("🚀 ~ EvaluationBoard ~ evaluationMyDashboardIdeaHistory:", evaluationMyDashboardIdeaHistory)
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const pageHierarchy = [
    { string: 'Home', navigate: () => Navigation.navigateToExplore() },
    { string: 'Ideas', navigate: () => Navigation.navigateToAllIdeas() },
    { string: "Evaluation Board " }
  ]


  return (<>
    <Breadcrumbs crumbs={pageHierarchy} />
    <Container>
      <h1> <i className="icon-idea" /> {i18n.t('SCREEN.EVALUATION_BOARD')}  </h1>

      <div className={classes.gridbox}>
        <div className={classes.sidebox}>
          <Tabs value={value}
            orientation="vertical"
            onChange={handleChange}
            aria-label="simple tabs ">
            <Tab label="My Evaluation" {...a11yProps(0)} />
            <Tab label="History Evaluation" {...a11yProps(1)} />
            {isAdmin && (<>
              <Tab label="Innovate" {...a11yProps(2)} />
              <Tab label="Nova" {...a11yProps(3)} />
            </>)}
          </Tabs>
        </div>
        <div className={classes.contentbox}>
          <TabPanel value={value} index={0}>
            <EvaluationMyIdea {...props} />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <EvaluationMyIdeaHistory getMyEvaluationDashboardIdeaHistory={getMyEvaluationDashboardIdeaHistory} {...props} />
          </TabPanel>
          <TabPanel value={value} index={2}>
            <EvaluationInnovateIdea getEvaluationDashboardIdea={getEvaluationDashboardIdea} {...props} />
          </TabPanel>
          <TabPanel value={value} index={3}>
            <EvaluationBoardNOVA getEvaluationIdea={getEvaluationIdea} {...props} />
          </TabPanel>

        </div>
      </div>

    </Container>


  </>)

}


export default withStyles(styles)(EvaluationBoard)



const TabPanel = (props) => {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (

        <div>{children}</div>

      )}
    </div>
  );
}